export default __webpack_public_path__ + "static/media/bankingFinanceBg@2x.77443698.png";